// Displays a hint containing static HTML...or at least HTML in which no
// extra JS behavior is provided by the hint system.

export default class StaticHint {
  constructor($el, $container, token, params, query) {
    this.$el = $el;
    this.$container = $container;
    this.token = token;
    this.params = params;
    this.query = query;
    this.$container.html(this.params.template).show();
  }

  destroy() {}

  setToken() {}
}
